// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3059":"5158c4c07c05faef","4013":"5c2d0d50c67998ac"}[chunkId] + ".css";
};